import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Markdown } from "component-library";
import { FormWrapper } from "../../components/form-wrapper";
import { routes } from "../../routing/routes";
import { useFormState } from "../../components/context/hooks/useFormState";
import { ControlledCheckbox } from "../../components/form/controlled-checkbox";
import { useTranslation } from "react-i18next";
import { usePraxis } from "../../praxis-config/praxis-context";
import { useLocalizedText } from "../../praxis-config/use-localized-text";

export const CancelAppointmentPage: React.FC = () => {
  const navigate = useNavigate();
  const { updateFormState, formState } = useFormState();
  const { control, handleSubmit, getValues } = useForm<{ cancel: boolean }>({
    defaultValues: { cancel: formState.cancellationCostAccepted || false },
  });
  const { t } = useTranslation();
  const { config } = usePraxis();
  const markdown = useLocalizedText(config.texts.cancelAppointment);

  const onSubmit = () => {
    updateFormState({ cancellationCostAccepted: getValues().cancel });

    navigate(routes.questionnaire.additionalPayment);
  };

  return (
    <FormWrapper onSubmit={handleSubmit(onSubmit)}>
      <div className="flex flex-col gap-7 my-4">
        <span className="text-2xl font-light text-text-primary text-center">
          {t("pages.cancel_appointment.title")}
        </span>
        <Markdown>{markdown}</Markdown>
      </div>
      <div className="mt-10 w-full">
        <ControlledCheckbox control={control} name="cancel" required>
          <span className="text-base font-normal">
            {t("pages.cancel_appointment.checkbox_label")}
          </span>
        </ControlledCheckbox>
      </div>
    </FormWrapper>
  );
};
